export default __webpack_public_path__ + "static/media/loading.dddd8b8b.svg";